import React, { useState, useEffect, useRef } from "react"
import save from "../images/save.png"
import comment from "../images/comment.png"
import like from "../images/like.png"
import favors from "../images/favors.jpg"
import iphone from "../images/iphone.jpg"
import prev from "../images/prev.png"
import next from "../images/next.png"
import ShopOverview from "./ShopOverview"
import axios from "axios"
import { Link, NavLink, useLocation } from "react-router-dom"
import { Button, CircularProgress, Skeleton ,IconButton, Tooltip} from "@mui/material"
import AddIcon from '@mui/icons-material/Add';
import TextArea from 'antd/es/input/TextArea';
import {motion} from "framer-motion"
import { Image, Input, Radio } from "antd"
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import moment from "moment"
import AddLocationAltIcon from '@mui/icons-material/AddLocationAlt';
import FavoriteIcon from '@mui/icons-material/Favorite';
import CommentIcon from '@mui/icons-material/Comment';
import BookmarkIcon from '@mui/icons-material/Bookmark';
import InfoIcon from '@mui/icons-material/Info';
import "../styles/Post.css"
import DeleteIcon from '@mui/icons-material/Delete';
import {Swiper, SwiperSlide} from "swiper/react";
import { Navigation, Pagination, Scrollbar, A11y, EffectFade } from 'swiper/modules';
import 'swiper/css/bundle'
import 'swiper/css'
import 'swiper/css/effect-fade';
import 'swiper/css/pagination';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment } from '@fortawesome/free-solid-svg-icons';

export default function EachShopPost({propsData}) {

   const location = useLocation()
   const [routes,setRoutes]=useState(location.pathname.split("/"))
   let [equilizer,setEquilizer]=useState(0)
   let [loadGetPost,setLoadGetPost]=useState(false)
   let [errorGetPost,setErrorGetPost]=useState(false)
   let [AllShopPosts,GetAllShopPosts]=useState([])


  
   useEffect(()=>{
    setLoadGetPost(true)
    axios.get(`${process.env.REACT_APP_URL}/api/post/GetAllShopePosts/${routes[2]}`, {
      headers: {
        Authorization: `Bearer ${propsData.userData?.token}`,
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((response) => {
        setLoadGetPost(false)
     // console.log(response.data);
      GetAllShopPosts(response.data)
      setErrorGetPost("")
    })

    .catch((error) => {
      //console.error(error);
      setErrorGetPost(true)
      
    });
},[equilizer,propsData.equilizer,propsData.currentShope])


   const [image, setImage] = useState([]) 
   const [AddPostPage,HandleAddPostPage]=useState(false)
   const [AddPostText,HandleAddPostText]=useState("")
   const [value, setValue] = useState("subscribers");

   let [newPost,makeNewPost]=useState({
    postText:AddPostText,
    img:[],
  })

  const handleChange = (e) => {
    let image=e.target.files
    makeNewPost(element=>{ 
      return{...element,img:image}
    })
  }

  
  const handleTextChanginging=(e)=>{
    HandleAddPostText(e.target.value)
    makeNewPost(element=>{ 
      return{...element,postText:e.target.value}
    })
  }

   let [sampleImage,setSampleImages]=useState([])

  useEffect(()=>{
    if(newPost.img){
        for (let i = 0; i < newPost.img.length; i++) {
           // console.log(newPost.img[i]);
            if (newPost.img[i].type?.startsWith('image/')) {
                let url=URL.createObjectURL(newPost.img[i])
                setSampleImages(e=>[...e,url])
            }
        }
    }
  },[newPost.img])
   

  let [loading,setLoading]=useState(false)
  let [error,GetError]=useState(false) 

  const CreatePost=()=>{
    setLoading(true)
   // console.log(newPost);
    if(newPost.img.length===0&&newPost.postText.length<1){
        GetError("Please, at least provide one of the fields.")
        setTimeout(()=>{
            GetError("")
          },5000)
        setLoading(false)
        return
    }

    let fd=new FormData()                                                               
    let url=`${process.env.REACT_APP_URL}/api/post/AddNewposts`
    if(newPost.img.length>0){
        for (let i = 0; i < newPost.img.length; i++) {
        //  console.log(newPost.img[i]);
          if (newPost.img[i].type?.startsWith('image/')) {
                fd.append("imgs",newPost.img[i])

          }
        }
    }
    if(newPost.postText.length>0){
        fd.append("text",newPost.postText)
    }
    fd.append("shopeId",propsData.currentShope)
    
   axios.post(url,fd, {
    headers: {
       authorization:`Bearer ${ propsData.userData?.token }`,
       'Content-Type': 'multipart/form-data',
    } 
   })

   .then(res=>{
    setLoading(false)
    //console.log(res.data);
    setEquilizer(equilizer+1)
    makeNewPost({
        postText:AddPostText,
        img:[],
    })
    setSampleImages([])
    HandleAddPostText("")
    HandleAddPostPage(false)
    GetError("")

  })

  .catch(error=>{
   // console.log(error);
    setLoading(false)
    GetError(error.response.data.error||"Error occured pleasee try again.")
    setTimeout(()=>{
      GetError("")
    },5000)
    })
  }

   const CancelCreatingPost=()=>{
    HandleAddPostPage(false)
    setSampleImages([])
    HandleAddPostText("")
   }
  
  let errorSample=[1,2,3,4,3,2,3]
    return (
     <>
        <div className="shop-posts">
           <div  className="shop-posts-container">
                <ShopOverview propsData={propsData}/>
                
                <div className="shop-posts-body from-each-shop">
                    {((!loadGetPost&&!errorGetPost)&&propsData.currentShope===routes[2])&&<div className="shop-posts-body-createPost">
                        <Button onClick={()=>HandleAddPostPage(!AddPostPage)}><AddIcon/></Button>
                    </div>}
                    {(AllShopPosts.length===0&&!loadGetPost&&!errorGetPost )?
                     <div className="no-post">No Post yet</div> 
                      : 
                      <div  className="shop-posts-body-all">
                        {(loadGetPost||errorGetPost)
                          ?
                          <>
                              {errorSample.map((e,index)=>{
                                return(
                                    <div key={index}  className="shop-posts-body-all-error">
                                        <div  className="shop-posts-body-all-error-head">
                                              <div><Skeleton variant="circular" width={60} height={60} /></div>
                                              <div>
                                                  <div>  <Skeleton animation="wave" height={10} width="50px" /></div>
                                                  <div>  <Skeleton animation="wave" height={10} width="50px" /></div>
                                              </div>
                                        </div>
                                        <div className="shop-posts-body-all-error-body"> <Skeleton  sx={{ height: 190 }} animation="wave" variant="rectangular" /></div>
                                        
                                    </div>

                                )
                              })}
                            </>
                          :
                          <>
                                {
                                    AllShopPosts.map(item => {

                                        return <EachPost item={item} key={item._id} propsData={propsData} route={routes[2]}/>
                                        
                                    })
                                }
                          
                          </>
                        }
                        {!(loadGetPost&&errorGetPost)&&<div style={{margin:"0 0 20px 0",textAlign:"center",opacity:0.5}}>No Post Left</div>}
                      </div>
                    }
                </div>

           </div>
       </div>
       {AddPostPage&&
           <form 
             enctype="multipart/form-data"
             className="shop-posts-body-createPost-page">
              <motion.div
              initial={{scale:0,opacity:0}}
              animate={{scale:1,opacity:1}}
              transition={{duration:0.4}}
              enctype="multipart/form-data"
              className="shop-posts-body-createPost-page-box"
                 >
                    <div>
                        <Radio.Group onChange={(e)=>setValue(e.target.value)} value={value}>
                            <Radio value={"all"}>All</Radio>
                            <Radio value={"subscribers"}>Sunscribers Only</Radio>
                        </Radio.Group>
                    </div>
                   <div   className="shop-posts-body-createPost-page-box-input">
                        <TextArea   
                          autoFocus={true}
                            autoSize={{
                            minRows:8,
                            maxRows: 10,
                            }} placeholder='Text' value={AddPostText}  onChange={handleTextChanginging}/>
                    </div>
                    <div className="shop-posts-body-createPost-page-box-image">
                        <div className={`shop-posts-body-createPost-page-box-image-upload ${sampleImage.length>0&&"shop-posts-body-createPost-page-box-image-upload-image-added"}`}>
                                <label>
                                    <input type="file" multiple name="img" onChange={handleChange} className='file-input-newPost'/>
                                    <div>
                                         <AddPhotoAlternateIcon style={{fontSize:"35px"}}/>
                                         <div>Add Photo / video</div>
                                    </div>                                  
                                </label>
                        </div>
                       {sampleImage.length>0&&<div className="shop-posts-body-createPost-page-box-image-selected">
                              {sampleImage.map(src=>{
                                return <div><Image src={src} width={100} height={100}/></div>
                                })}
                         </div>}
                     </div>
                    <div className="shop-posts-body-createPost-page-box-button">
                        {loading?<CircularProgress size={25}/>:
                          <>
                            <div><Button onClick={CreatePost}>Post</Button></div>
                            <div><Button onClick={CancelCreatingPost}>Cancel</Button></div>
                          </>
                        }
                    </div>  
                     {error&&<div style={{textAlign:"center",color:"red",fontSize:"13px"}}>{error}</div>}
              </motion.div>
           </form>
       }
     </>
    )
} 
const EachPost = ({item,propsData,route}) => {

  const [index, setIndex] = useState(0);

  const postTextRef = useRef(null);
const [showSeeMoreLink, setShowSeeMoreLink] = useState(false);

  useEffect(() => {
    checkTextHeight();
  }, []);

  const checkTextHeight = () => {
    if (postTextRef.current.clientHeight > 60) {
      setShowSeeMoreLink(true);
    }
  };

  let [seeLess,handleSeeLess]=useState(false)

  const handleSeeMoreClick = () => {
    postTextRef.current.style.maxHeight = 'none';
    setShowSeeMoreLink(false);
    handleSeeLess(true)
  };

  const handleSeeLessClick = () => {
    postTextRef.current.style.maxHeight = '60px';
    setShowSeeMoreLink(true);
    handleSeeLess(false)
  };

  let [commentPage,handleCommentPage]=useState(false)
  let [pageLiked,handlePageLiked]=useState(item?.likes?.includes(propsData.currentShope))
  let [amountOfLikes,handleAmountOfLikes]=useState(item?.likes?.length)
  let [amountOfComments,handleAmountOfComments]=useState(item?.comments?.length)
  let [pageSaved,handlePageSaved]=useState(propsData?.userData?.data?.savedPost?.includes(item._id))

  const SavePost=()=>{
    
    axios.put(`${process.env.REACT_APP_URL}/api/user/savePost`,{postId:item?._id}, {
      headers: {
        Authorization: `Bearer ${propsData.userData?.token}`,
        'Content-Type': 'application/json'
      },
    })
    .then((response) => {
     handlePageSaved(response.data?.msg==="saved"?true:false)
    })
    .catch((error)=>{
       //console.log(error);
    })
  }

  const LikePost=()=>{
    handlePageLiked(!pageLiked)
    if(!pageLiked){
      handleAmountOfLikes(amountOfLikes+1)
    }
    else{
      handleAmountOfLikes(amountOfLikes-1)
    }
    let values={
      postId:item._id,
      shopId:propsData.currentShope
    }
    
    axios.put(`${process.env.REACT_APP_URL}/api/post/Like_UnlikePost`,values, {
      headers: {
        Authorization: `Bearer ${propsData.userData?.token}`,
        'Content-Type': 'application/json'
      },
    })
    .then((response) => {
    //  //console.log(response.data);
    })
    .catch((error)=>{
       //console.log(error);
    })
  }

  let [allLikes,handleAllLikes]=useState([])
  useEffect(()=>{
    axios.get(`${process.env.REACT_APP_URL}/api/post/GetpostLikes/${item?._id}`, {
      headers: {
        Authorization: `Bearer ${propsData.userData?.token}`,
        'Content-Type': 'application/json'
      },
    })
    .then((response) => {
     // //console.log(response.data);
      handleAllLikes(response.data)
    })
    .catch((error)=>{
       //console.log(error);
    })
  },[amountOfLikes])

  let [commentValue,handleCommentValue]=useState("")
  let [commentError,handlecommentError]=useState("")


  const AddComment =()=>{
      handlecommentError(true)
      let values={
        text:commentValue,
        postId:item._id,
        shopId:propsData.currentShope,
      }

      axios.put(`${process.env.REACT_APP_URL}/api/post/Add_comment_post`,values, {
        headers: {
          Authorization: `Bearer ${propsData.userData?.token}`,
          'Content-Type': 'application/json'
        },
      })
      .then((response) => {
       // //console.log(response.data);
        handlecommentError(false)
        handleAmountOfComments(amountOfComments+1)
        handleCommentValue("")
      })
      .catch((error)=>{
         //console.log(error);
      })
  }

  const handleKeyDown = (event) => {
    if (event.key === 'Enter'&&(commentValue&&commentValue.length>0)) {
      event.preventDefault(); // Prevent the default behavior of newline insertion
      AddComment(); // 
    }
  };

  let [allComments,handleAllComments]=useState([])
  let [allCommentsLoad,handleAllCommentsLoad]=useState(false)

  useEffect(()=>{
    handleAllCommentsLoad(true)
    axios.get(`${process.env.REACT_APP_URL}/api/post/GetpostComments/${item?._id}`, {
      headers: {
        Authorization: `Bearer ${propsData.userData?.token}`,
        'Content-Type': 'application/json'
      },
    })
    .then((response) => {
      ////console.log(response.data);
      let reversed=response.data.reverse()
      handleAllComments(reversed)
      handleAllCommentsLoad(false)
    })
    .catch((error)=>{
       //console.log(error);
    })
  },[amountOfComments])


  ////console.log(item);
  let[detailPage,handleDetailPage]=useState(false)
  let[load_delete,handle_load_delete]=useState(false)
  let[error_delete,handle_error_delete]=useState(false)
  
  const deletePost=()=>{
    handle_load_delete(true)
    axios.delete(`${process.env.REACT_APP_URL}/api/post/Removepost/${item?._id}`, {
      headers: {
        Authorization: `Bearer ${propsData.userData?.token}`,
        'Content-Type': 'application/json'
      },
    })
    .then((response) => {
     // //console.log(response.data);
      propsData.setEquilizer(propsData.equilizer+2)
      handle_load_delete(false)
    })
    .catch((error)=>{
      handle_load_delete(false)
      // //console.log(error);
       handle_error_delete(error?.response?.data?.error||"Try again latter")
      setTimeout(()=>{
        handle_error_delete("")
      },6000)
    })

  }
 
  // {formatDistanceToNow(new Date(item.updatedAt), { addSuffix: true, locale: enUS })}
  return (
    <>
      <div className={`each-shop-eachPost-container ${seeLess&&"each-shop-eachPost-container-long"}`}>
          <div className="each-post-header">
              <Link to={`/shop/${item?.shope?._id}`} style={{color:"inherit",textDecoration:"none"}}>
                    <div  className="each-post-header-pic_name">
                        <div><img className="shop-profile-picture" src={item.shope.coverPic.fileUrl} /></div>
                        <div style={{display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"column",gap:"4px"}}>
                            <div className="each-post-header-shopName">{item.shope.shope_name}</div>
                            <div className="each-post-header-shopLocation"><AddLocationAltIcon style={{fontSize:"8px",color:"red"}}/> {item.shope.country}</div>
                        </div>

                    </div>
              </Link>
              <div  className="each-post-header-time"> {moment(new Date(item.createdAt)).fromNow()}</div>
          

                  {  (propsData.userData?.data?._id===item.postedBy._id||propsData.userData?.data?._id===item.shope.ownedBy)&&
                    <div>
                      <Tooltip title="Details">
                          <IconButton onClick={()=>handleDetailPage(!detailPage)}><InfoIcon style={{color:"rgb(70, 70, 158)"}}/>
                          </IconButton>
                        </Tooltip>
                        </div>}
            
          </div>
          
          <div className="each-post-body">
              <div  ref={postTextRef} className="each-post-body-text">{item?.text}</div>
              {showSeeMoreLink && (
                <a className="see-more-link" onClick={handleSeeMoreClick}>
                  See More
                </a>
              )}
               {seeLess && (
                <a className="see-more-link" onClick={handleSeeLessClick}>
                  See less
                </a>
              )}
              {item.images.length>0&&
               <div className="each-post-body-images">
                  <Slider slides={item.images}/>
              </div>}
               


          </div>
          
          <div className="post-like-comment-save">
              <div style={{display:"flex",alignItems:"center",gap:"1px"}}>
                      <div><IconButton onClick={LikePost}><FavoriteIcon style={{color:pageLiked?"red":"rgb(143, 97, 6,0.3)"}}/></IconButton></div>
                      <div className="post-like-comment-save-number">{amountOfLikes}</div>
               </div>
               <div style={{display:"flex",alignItems:"center",gap:"1px"}}>
                      <div>
                        <IconButton onClick={()=>handleCommentPage(!commentPage)}>
                        <FontAwesomeIcon icon={faComment} color="rgb(143, 97, 6,0.3)"/>

                         </IconButton></div>
                      <div className="post-like-comment-save-number">{amountOfComments}</div>
               </div>

               <div>
                 <Tooltip title={pageSaved?"Unsave post":"Save post"}>
                    <IconButton onClick={SavePost}><BookmarkIcon style={{color:pageSaved?"rgb(143, 97, 6)":"rgb(143, 97, 6,0.3)"}}/></IconButton>
                </Tooltip>
                </div>  
            </div>
        
           {commentPage&& 
             <div className="post-add-comment">
                <div className="post-add-comment-input">
                  <Input  onKeyDown={handleKeyDown} placeholder="comment" value={commentValue}onChange={(e)=>handleCommentValue(e.target.value)}/>
                </div>
                {(commentValue.length>0&&!allCommentsLoad)&&<div><Button disabled={commentError} onClick={AddComment}>Post</Button></div>}
            </div>}
            
            {commentPage&& <div className="post-All-comment">
                  {allComments.map(e=>{
                    return <EachComments postId={item._id} allComments={allComments} handleAllComments={handleAllComments} propsData={propsData} data={e} key={e._id}/>
                  })}
            </div>}
      </div>
      
      {detailPage&&
      <div className="each-shop-eachPost-DetailPage">
         <div className="each-shop-eachPost-DetailPage-box">
            <div className="each-shop-eachPost-DetailPage-text">Poseted By, {item.postedBy.username}</div>
            <div className="each-shop-eachPost-DetailPage-likes">
              {allLikes.map(e=>{
                return<PostLikes key={e._id} data={e}  />
              })}
            </div>

            {error_delete&&<div style={{color:"red",textAlign:"center",margin:"10px 0 10px"}}>{error_delete}</div>}
            
            <div className="each-shop-eachPost-DetailPage-buttons">
               {load_delete?<CircularProgress  size={25}/>:
                 <>
                  <div  className="each-shop-eachPost-DetailPage-buttons-delete"><Button onClick={deletePost}>Delete</Button></div>
                  <div  className="each-shop-eachPost-DetailPage-buttons-cancel"><Button onClick={()=>handleDetailPage(!detailPage)}>Cancel</Button></div>
                 </>
               }
            </div>
          </div>
      </div>}
    </>
  )

}

const PostLikes=({data})=>{

  return(
   <Link to={`/shop/${data._id}`} style={{color:"inherit",textDecoration:"none"}}>
      <div className="each-shop-eachPost-DetailPage-likes-each">
        <div><img src={data?.coverPic?.fileUrl} alt="Profile.pic" width={50} height={50}/></div>
        <div>{data.shope_name}</div>
      </div>
    </Link>
  )
}


const Slider = ({ slides }) => {
  return (
    <Swiper
      modules={[ Pagination, Scrollbar, A11y,EffectFade]}
      spaceBetween={10}
      slidesPerView={1}
      pagination={{ clickable: true }}
      style={{ boxShadow: "none",height:"100%" }}
    >
      {slides.map((slide,index) => (
        <SwiperSlide key={index} >
          <img src={`${slide.fileUrl}`} style={{objectFit:"cover"}} className='swiper-image' height={"100%"} width={"100%"} alt={"slider.pic"}/>
        </SwiperSlide>
      ))}
    </Swiper>
  )

}

const EachComments=({data,propsData,handleAllComments,allComments,postId})=>{

  //console.log(data);
  let [pageLiked,handlePageLiked]=useState(data?.likes?.includes(propsData.currentShope))
  let [amountOfLikes,handleAmountOfLikes]=useState(data?.likes?.length)
  
  let [allCommentsOfComments,getAllCommentsOfComments]=useState([])
  let[equilizer,setEquilizer]=useState(0)
   
  useEffect(()=>{
    axios.get(`${process.env.REACT_APP_URL}/api/post/GetCommentLikes/${data?._id}`, {
      headers: {
        Authorization: `Bearer ${propsData.userData?.token}`,
        'Content-Type': 'application/json'
      },
    })
    .then((response) => {
      //console.log(response.data);
      let shopLikedThisComment=response.data.filter(e=>{
         return e._id===propsData.currentShope
      })
      handlePageLiked(shopLikedThisComment.length>0)
     handleAmountOfLikes(response.data.length)
    })
    .catch((error)=>{
       //console.log(error);
    })
  },[data?._id])

  const LikeComment=()=>{
      handlePageLiked(!pageLiked)
      if(!pageLiked){
        handleAmountOfLikes(amountOfLikes+1)
      }
      else{
        handleAmountOfLikes(amountOfLikes-1)
      }
      let values={
        commentId:data._id,
        shopId:propsData.currentShope
      }
      
      axios.put(`${process.env.REACT_APP_URL}/api/post/likeUnlikepostComments`,values, {
        headers: {
          Authorization: `Bearer ${propsData.userData?.token}`,
          'Content-Type': 'application/json'
        },
      })
      .then((response) => {
         //console.log(response.data);
      })
      .catch((error)=>{
         //console.log(error);
      })

  }

  useEffect(()=>{
       axios.get(`${process.env.REACT_APP_URL}/api/post/GetCommentPostComments/${data?._id}`, {
        headers: {
          Authorization: `Bearer ${propsData.userData?.token}`,
          'Content-Type': 'application/json'
        },
      })
      .then((response) => {
        //console.log(response.data);
        getAllCommentsOfComments(response.data);
      })
      .catch((error)=>{
         //console.log(error);
      })
  },[equilizer])

  const DeleteComment=()=>{
    let values={
      shopId:propsData.currentShope,
      commentId:data._id,
    }
    axios.put(`${process.env.REACT_APP_URL}/api/post/Delete_comment_post`,values, {
      headers: {
        Authorization: `Bearer ${propsData.userData?.token}`,
        'Content-Type': 'application/json'
      },
    })
    .then((response) => {
      // //console.log(response.data);
       let fileteredComments=allComments.filter(e=>{
         return e._id!==data?._id
       })
       handleAllComments(fileteredComments)
    })
    .catch((error)=>{
       ////console.log(error);
    })
  }

  const [openComment,handleOpenComment]=useState(false)
  const [commentValue,handleCommentValue]=useState("")

  const handleSubmit=(event)=>{

    if (event.key === 'Enter'&&(commentValue&&commentValue.length>0)){
        let values={
          text:commentValue,
          commentId:data._id,
          shopId:propsData.currentShope,
          postId:postId
        }
        //console.log(values);
        handleCommentValue("")
        axios.put(`${process.env.REACT_APP_URL}/api/post/CommentPostComments`,values, {
          headers: {
            Authorization: `Bearer ${propsData.userData?.token}`,
            'Content-Type': 'application/json'
          },
        })
        .then((response) => {
          //console.log(response.data);
          handleCommentValue(allCommentsOfComments+1)
          setEquilizer(equilizer+1)
          
        })
        .catch((error)=>{
          //console.log(error);
        })

    }
  }

  return(
    <div className="post-All-comment-each-container">
      <div className="post-All-comment-each-top">
          <Link style={{color:"inherit",textDecoration:"none",width:"fit-content"}} to={`/${data.commentedShop._id}`}>
            <div className="post-All-comment-each-profile">
              <div className="post-All-comment-each-profile-picture">
                <img alt="profile.pic" src={data.commentedShop.coverPic.fileUrl}  /></div>
                <div className="post-All-comment-each-profile-text">
                  {data.commentedShop.shope_name}</div>
            </div>
          </Link>
          <div className="each-post-header-time"> {moment(new Date(data.createdAt)).fromNow()}</div>
      </div>

      <div className="post-All-comment-each-comment">{data.text}</div>
       
 
      <div className="post-All-comment-each-buttons">
          <div style={{display:"flex",alignItems:"center",flexDirection:"column"}}>
             <IconButton onClick={LikeComment} ><FavoriteIcon style={{color:pageLiked?"red":"rgb(143, 97, 6,0.3)",fontSize:"18px"}}/></IconButton>
             <div style={{fontSize:"10px"}}>{amountOfLikes}</div>
          </div>

          <div  style={{display:"flex",alignItems:"center",flexDirection:"column"}}>
              <IconButton onClick={()=>handleOpenComment(!openComment)}><FontAwesomeIcon icon={faComment} style={{fontSize:"18px",color:"rgb(143, 97, 6,0.3)"}}/></IconButton>
              <div style={{fontSize:"10px"}}>{allCommentsOfComments.length}</div>
          </div>

          {data?.commentedShop?._id===propsData.currentShope&&<div>
              <IconButton onClick={DeleteComment}><DeleteIcon style={{fontSize:"18px",color:"red"}}/></IconButton>
          </div>}
      </div>
     
    {openComment&& 
       <div>
          <div className="post-All-comment-each-commentInput">
              <Input value={commentValue} onKeyDown={handleSubmit} onChange={(e)=>handleCommentValue(e.target.value)}/>
          </div>
          {allCommentsOfComments.length>0&&<div className="post-All-comment-each-commentsAll">
              {allCommentsOfComments.map((e,index)=>{
                 return <EachComments postId={postId} allComments={allCommentsOfComments} handleAllComments={getAllCommentsOfComments} propsData={propsData} data={e} key={index}  />
              })}
          </div>}

       </div>

            }
     
       <hr/>

    </div>
  )
}

